<template>
    <v-dialog content-class="v-csv-dialog"
              value="true"
              width="80%"
              persistent
              no-click-animation>
      <v-card>
        <v-card-title class="headline grey lighten-2"
                      v-if="hasTitle"
                      primary-title>
          <slot name="title"/>
        </v-card-title>

        <v-card-text>
          <slot name="instructions"/>
          <v-csv-viewer :headers="headers" :items="file.items" hide-per-row-menu>
            <template v-if="fields.length > 0" v-slot:footer>
              <td v-for="(header, header_index) in headers" :key="`header-${header_index}`">
                <v-select
                  :items="getOptions(header)"
                  item-text="field"
                  item-value="field"
                  label="Assign to..."
                  solo
                  :background-color="header.field ? 'indigo' : 'grey lighten-2'"
                  :dark="header.field ? true : false"
                  :value="header.field"
                  @change="updateHeaderSelection($event, header)"
                  clearable
                  hide-details
                >
                  <template v-slot:item="{ item }">
                      {{ item.field }}&nbsp;<span v-if="item.required" class="red--text" :class="item.disabled ? 'text--lighten-3' : 'text--darken-2'">*</span>
                  </template>
                </v-select>
              </td>
            </template>
          </v-csv-viewer>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="success darken-2"
            @click="close"
            :data-test="`${$attrs['data-test-attrs']}Save`"
          >
            Save
          </v-btn>
          <v-btn
            @click="close(false)"
          >
            Cancel
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
</template>

<script>
import VCsvViewer from '@/components/CsvViewer'
import { Bus } from '@/bus'

export default {
  name: 'CsvDialog',
  components: {
    VCsvViewer
  },
  props: {
    // The selected header index
    file: {
      type: Object,
      required: true
    },
    fields: {
      type: Array,
      default () {
        return []
      },
      required: false
    },
    hidePerRowMenu: {
      type: Boolean,
      default: false,
      required: false
    }
  },
  /**
   * Bind the header index to the v-model and emit change event
   */
  model: {
    prop: 'file',
    event: 'change'
  },
  computed: {
    /**
     * Map CSV headers to match vuetify data table component requirements
     */
    headers () {
      return this.file.headers.map((header, index) => {
        return {
          ...header,
          index,
          align: 'left',
          sortable: false
        }
      })
    },
    hasTitle () {
      return this.$slots.title !== undefined
    },
    requiredFields () {
      return this.fields.filter(field => {
        return field.required === true
      })
    }
  },
  methods: {
    /**
     * v-model handler
     */
    handleInput (headers) {
      this.$emit('change', {
        ...this.file,
        headers
      })
    },
    /**
     * Close the CSV Dialog
     */
    close (isSave = true) {
      let isInvalid = false

      this.fields.forEach(field => {
        if (this.isInvalid(field)) {
          isInvalid = true
        }
      })
      // Error when the user has not selected an header and try to persist the CSV file
      if (isInvalid && isSave) {
        Bus.$emit('alert', { color: 'error', message: 'Please, assign required fields before saving!' })
        return
      }
      this.$emit('close', isSave)
    },
    /**
     * @todo doc
     */
    isInvalid (field) {
      const isSelected = this.headers.find(header => header.field === field.name) !== undefined
      return (field.required === true && !isSelected)
    },
    updateHeaderSelection (field, updatedHeader) {
      let { headers } = this.file

      headers
        .find(header => header.value === updatedHeader.value)
        .field = field || null

      this.handleInput(headers)
    },
    getOptions (header) {
      const selected = this.headers.map(header => header.field)

      return this.fields.map(field => {
        let disabled = false

        if (selected.indexOf(field.name) !== -1) {
          disabled = (header.field !== field.name)
        }
        return {
          field: field.name,
          disabled,
          required: field.required
        }
      })
    }
  }
}
</script>

<style lang="sass">
.v-csv-dialog
  tfoot
    tr
      td
        background-color: #eee
        padding: 0 !important
        &::before
          font-family: 'Material Icons'
          content: '\e5cf'
          color: #333
          text-align: center
          font-weight: bold
          display: block
          width: 100%
          line-height: 1.5rem
          font-size: 24px
          background: #bbb
          padding: 6px
        .v-input.v-text-field .v-input__control
          .v-input__slot
            margin: 0 !important
            border-radius: 0 !important
            box-shadow: none
            -webkit-box-shadow: none
        .v-messages
          min-height: 0
</style>
